<template>
    <v-card>
        <v-card-title style="background-color: lightgray">
            <span class="text-h5">Success</span>
        </v-card-title>
        <v-card-text style="background-color: lightgray">
            <v-container class="d-flex flex-column justify-content-center">
                <div class="svg-container text-center" v-if="success">
                    <svg class="ft-green-tick" xmlns="http://www.w3.org/2000/svg" height="100" width="100"
                         viewBox="0 0 48 48"
                         aria-hidden="true">
                        <circle class="circle" fill="#5bb543" cx="24" cy="24" r="22"/>
                        <path class="tick" fill="none" stroke="#FFF" stroke-width="6" stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-miterlimit="10" d="M14 27l5.917 4.917L34 17"/>
                    </svg>
                </div>
                <div class="mt-4 text-center" v-html="message"></div>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: "DoneMessageModal",
    props: {
        'message': null,
        'success': {default: true}
    }
}
</script>

<style scoped>
    .custom-modal-body{
        height: 400px;
        color: green;
    }
</style>
